/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Missing_DescriptionInputs */

const fr_marker_missing_description = /** @type {(inputs: Marker_Missing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette entrée n'est plus d'actualité, elle devrait disparaitre au prochain rafraichissement de la carte.`)
};

const en_marker_missing_description = /** @type {(inputs: Marker_Missing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This entry is no longer current and should disappear on the next map refresh.`)
};

/**
* | output |
* | --- |
* | "This entry is no longer current and should disappear on the next map refresh." |
*
* @param {Marker_Missing_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_missing_description = /** @type {((inputs?: Marker_Missing_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Missing_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_missing_description(inputs)
	return en_marker_missing_description(inputs)
});